// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DEgCaJ{overflow:auto;width:100%;height:100%}.DEgCaJ::-webkit-scrollbar{background:transparent}.DEgCaJ:vertical{width:14px}.DEgCaJ:horizontal{height:14px}.DEgCaJ::-webkit-scrollbar-thumb{background-color:rgba(var(--textColor), 1);background-clip:padding-box;border:4px solid transparent;border-radius:7px;-webkit-transition:background-color 0.2s;transition:background-color 0.2s}.DEgCaJ::-webkit-scrollbar-thumb:hover,.DEgCaJ::-webkit-scrollbar-thumb:active{background-color:rgba(var(--textColor), 0.8)}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scrollbar-wrapper": `DEgCaJ`,
	"scrollbarWrapper": `DEgCaJ`
};
export default ___CSS_LOADER_EXPORT___;
